<template>
  <FormHeader>
    <template #title>
      <p>
        {{ __('co_reg_lander_001_text_step_all_title') }}
      </p>
    </template>

    <template #subtext>
      <p>
        {{ __('co_reg_lander_001_text_step_all_intro') }}
      </p>
    </template>
  </FormHeader>

  <div class="grid gap-y-6">
    <ProgressBar
      :primary-color="primaryColor"
      progress="100"
    />
  </div>

  <div id="sub-step">
    <p class="text-4xl font-bold">
      {{ __('co_reg_lander_001_exit_thanks_text') }}
    </p>
  </div>

  <div class="text-gray-500 grid gap-y-4 text-lg font-semibold">
    <!-- eslint-disable vue/no-v-html -->
    <div
      class="text-sm italic"
      v-html="__('co_reg_lander_001_text_thanks_text')"
    />
    <!-- eslint-enable vue/no-v-html -->

    {{ __('co_reg_lander_001_text_exit_title') }}
  </div>

  <div
    v-for="(campaignSub, index) in campaignSubs"
    :key="index"
  >
    <ExitItem
      :campaign-sub="campaignSub"
      :primary-color="primaryColor"
      :secondary-color="secondaryColor"
    />
  </div>
</template>

<script setup>
import {ref} from 'vue';
import ProgressBar from '@timon/js/Templates/CO-REG-LANDER-001/Components/ProgressBar.vue';
import FormHeader from '@timon/js/Templates/CO-REG-LANDER-001/Components/FormHeader.vue';
import ExitItem from '@timon/js/Components/ExitItem.vue';

const props = defineProps({
  config: {
    type: Object,
    required: true,
  },

  campaignSubs: {
    type: Array,
    required: true,
  },

  variables: {
    type: Object,
    required: true,
  },
});

const primaryColor = ref(props.config.style?.primary);
const secondaryColor = ref(props.config.style?.secondary);
</script>
